import { action } from 'typesafe-actions'
import { ToolsMenuInfoType } from './types'

export const setInfoViewStatus = (payload: boolean) =>
  action(ToolsMenuInfoType.SET_INFO_VIEW_STATUS, payload)
